/* eslint-disable @typescript-eslint/no-explicit-any */
// Reference: https://www.apollographql.com/blog/apollo-client/how-to-use-apollo-client-with-next-js-13/
import { GetClientProps } from '~types/index'

import { ApolloClient } from '@apollo/client'

import isSSR from '@/utils/isSSR'

import { refreshOnUnauthenticatedLink } from './auth/refresh/client'
import authLinkCSR from './authLinkCSR'
import generateApolloClient from './generateApolloClient'
import generateDirectionalLink from './generateDirectionalLink'

let client: ApolloClient<any> | null = null

export const getClient = (props: GetClientProps) => {
  const ssrMode = isSSR()
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const { onError = () => {}, router } = props || {}
  const otherCustomLinks = [authLinkCSR, refreshOnUnauthenticatedLink]

  const directionalLink = generateDirectionalLink(
    onError,
    router,
    otherCustomLinks
  )

  if (!client || ssrMode) {
    client = generateApolloClient({ ssrMode, directionalLink })
  }

  return client
}
